import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import Vuex from 'vuex';
import getters from './getters';
import actions from './actions';
import i18n from './modules/i18n';
import cart from './modules/cart';
import user from './modules/user';
import layer from './modules/layer';
import search from './modules/search';
import script from './modules/script';
import seller from './modules/seller';
import request from './modules/request';
import category from './modules/category';
import wishlist from './modules/wishlist';
import analytics from './modules/analytics';
import sharedEnv from './modules/sharedEnv';
import pageActions from './modules/pageActions';
import searchEngine from './modules/searchEngine';
import navigationBar from './modules/navigationBar';
import routeNavigation from './modules/routeNavigation';
export default (function () {
  return new Vuex.Store({
    actions: actions,
    getters: getters,
    modules: {
      i18n: i18n,
      cart: cart,
      user: user,
      layer: layer,
      script: script,
      seller: seller,
      search: search,
      request: request,
      category: category,
      wishlist: wishlist,
      analytics: analytics,
      sharedEnv: sharedEnv,
      pageActions: pageActions,
      searchEngine: searchEngine,
      navigationBar: navigationBar,
      routeNavigation: routeNavigation
    }
  });
});